import {ref, cleanup, effect, html, clone, traverse, text, use, on, after, each, append, css, define} from "@intrnl/velvet/internal";
import {feedbacks} from '../store/FeedbackStore.js';
import {relformat} from '../misc/relformatter.js';
let template0 = html("<div class=aggregate> <span><!> feedback posted</span> <span><!> average rating</span> </div> <ul class=list> <!> </ul>");
let template1 = html("<li class=item> <div class=body> <div class=header> <span>rated <!></span> <span>posted <time></time></span> </div> <p class=text><!></p> </div> <button class=delete-btn> <svg class=delete-icon fill=none viewBox='0 0 24 24' stroke=currentColor stroke-width=2> <path stroke-linecap=round stroke-linejoin=round d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16'></path> </svg> </button> </li>");
let style0 = css(".aggregate{color:#fff;display:flex;justify-content:space-between;gap:8px;padding:0 16px 8px}.list{list-style-type:none;padding:0;margin:0}.item{display:flex;gap:8px;background-color:#fff;padding:8px 12px 8px 16px;border-radius:4px}.item+.item{margin-top:8px}.body{flex-grow:1}.header{color:#656570;font-size:14px;display:flex;justify-content:space-between;gap:8px;margin-bottom:2px}.text{margin:0}.delete-btn{background-color:transparent;height:24px;width:24px;padding:0;margin:0;border:0;border-radius:4px}.delete-btn:hover{color:#fff;background-color:#ed143d}.delete-icon{height:16px;width:16px;vertical-align:middle}");
function setup($$root, $$host) {
  function handleItemDelete(todo) {
    feedbacks.update($feedbacks => {
      return $feedbacks.filter(item => item.id !== todo.id);
    });
  }
  let average = ref(0);
  let $feedbacks = ref();
  cleanup(feedbacks.subscribe(value => $feedbacks.v = value));
  effect(() => {
    let total = 0;
    let count = $feedbacks.v.length;
    if (!count) {
      average.v = 0;
    } else {
      for (const item of $feedbacks.v) {
        total += item.score;
      }
      let raw = total / count;
      let truncated = Math.trunc(raw * 100) / 100;
      average.v = truncated;
    }
  });
  let fragment0 = clone(template0);
  let marker0 = traverse(fragment0, [0, 1, 0]);
  let marker1 = traverse(fragment0, [0, 3, 0]);
  let marker4 = traverse(fragment0, [2, 1]);
  let block1 = ($$root, item) => {
    let fragment1 = clone(template1);
    let marker2 = traverse(fragment1, [0, 1, 1, 1, 1]);
    let child0 = traverse(fragment1, [0, 1, 1, 3, 1]);
    let marker3 = traverse(fragment1, [0, 1, 3, 0]);
    let child1 = traverse(fragment1, [0, 3]);
    let child2 = traverse(fragment1, [0]);
    text(marker2, () => item.v.score);
    use(child0, relformat, () => item.v.date);
    text(marker3, () => item.v.message);
    on(child1, "click", () => handleItemDelete(item.v));
    after($$root, fragment1);
    return child2;
  };
  text(marker0, () => $feedbacks.v.length);
  text(marker1, () => average.v);
  each(marker4, block1, () => $feedbacks.v);
  append($$root, fragment0);
}
export default define("x-feedback-list", setup, {}, [style0]);
